import { customization } from '@yola/ws-sdk';
import store from 'src/js/store';

const updateCustomPalettes = (initialPalettes, updatedPalettes) => {
  customization.helpers
    .getCustomPalettesToDelete(initialPalettes, updatedPalettes)
    .forEach((id) => store.dispatch(customization.actions.deleteCustomColorPalette(id)));

  customization.helpers
    .getCustomPalettesToCreate(initialPalettes, updatedPalettes)
    .forEach((palette) => store.dispatch(customization.actions.addCustomColorPalette(palette)));

  customization.helpers
    .getCustomPalettesToUpdate(initialPalettes, updatedPalettes)
    .forEach((palette) => store.dispatch(customization.actions.updateCustomColorPalette(palette)));
};

export default updateCustomPalettes;
